<template lang="pug">
header
  .header-top.flex.items-end.justify-between
    router-link(:to="{path: '/'}")
      .logo
        span.intro Trang thông tin điện tử tổng hợp
    a.download(href="https://play.google.com/store/apps/details?id=com.xb.topnews&pid=news_official&c=news_official" alt='VN Ngày Nay' target="_blank" rel="noopener noreferrer")
      .download-googleplay
    //- a.ruleTips(href="/rule.pdf" target="_blank" rel="noopener noreferrer") Thông báo: V/v Khiếu nại của người dùng phát sinh từ nội dung quảng cáo do bên đối tác thực hiện
    .flex.items-end
      .date.caps.mr3 {{ curDate }}

      //- template(v-if="isLogin")
      //-   span.user-name.truncate(:title="userName") {{ userName }}
      //-   el-button.button-login.ml2(size="mini", @click="handleLogout") Đăng xuất
      //- template(v-else)
      //-   el-button.button-login(size="mini", @click="handleLoginButton('login')") Đăng nhập
      //-   el-button.button-login.light(size="mini", @click="handleLoginButton('signup')") Đăng ký

      template(v-if="isLogin")
        span.user-name.truncate(:title="userName") {{ userName }}
        ul.person-panel
        //-  li.panel-item(@click="gotoWinRecord") Lịch sử trúng thưởng
          li.panel-item(@click="handleLogout") Đăng xuất
        //- el-button.button-login.ml2(size="mini", @click="handleLogout") Đăng xuất
      template(v-else)
        el-button.button-login(size="mini", @click="handleFB") Login via Facebook
        //- el-button.button-login.light(size="mini", @click="handleLoginButton('signup')") Đăng ký

  nav(:style="{ height: navHeight }")
    ul.nav-list.my0.list-reset.flex(style="flex-wrap: wrap")
      div(class="more" @click="handleMore")
      router-link.truncate(
        v-for="item, idx in navList",
        :to="idx === 0? {path: '/'}: {path: '/', query: {id: item.cid}}",
        :key="idx",
        tag="li",
        :class="parseInt($route.query.id) === item.cid? 'active': !$route.query.id && idx === 0? 'active': ''")
        | {{ item.label }}
</template>

<script>
import Vue from "vue";
import { Button, MessageBox } from "element-ui";
import lang from "element-ui/lib/locale/lang/vi";
import locale from "element-ui/lib/locale";
import Register from "@/components/Register";
import * as cookies from "js-cookie";

locale.use(lang);

Vue.use(Button);

import Moment from "moment";
Moment.locale("vi");

export default {
  name: "header",
  props: ["cids", "isLogin", "userName"],
  data() {
    return {
      curDate: Moment().format("dddd, D/M/YYYY"),
      navList: [],
      navHeight: '40px'
    };
  },
  watch: {
    cids() {
      this.navList = [
        {
          // 首页
          cid: 0,
          label: "Trang chủ"
        },
        ...this.cids
      ];
    }
  },
  methods: {
    handleMore() {
      if (this.navHeight == '40px') {
        this.navHeight = 'auto'
      } else {
        this.navHeight = '40px'
      }
    },
    handleFB() {
      let that=this;
      FB.getLoginStatus(function(response) {
        if (response.status === "connected") {
          FB.api('/me',function(res){
            const {name}=res;
            that.$bus.emit("getUserInfo", {name:name,account:''});
            that.$bus.emit("logout",false);
            cookies.set("fb_name",name,{path:""});
            that.$router.push({ path: "/" });
          })
        } else {
          FB.login(
            ({ status, authResponse }) => {
              if (status === "connected") {
                FB.api('/me',function(res){
                  const {name}=res;
                  that.$bus.emit("getUserInfo", {name:name,account:''});
                  that.$bus.emit("logout",false);
                  cookies.set("fb_name",name,{path:""});
                })
                cookies.set("access_token", authResponse.accessToken, {
                  path: ""
                });
                cookies.set("fid", authResponse.userID, { path: "" });
                that.$router.push({ path: "/" });
              } else {
                alert("login filed!");
              }
            },
            { scope: "public_profile,email" }
          );
        }
      });
    },
    handleLoginButton(stat) {
      this.$bus.emit("getLoginStat", stat);
    },
    handleLogout() {
      MessageBox.confirm("Nhấn lần nữa để thoát ứng dụng!", "Thông báo", {
        type: "warning"
      })
        .then(() => {
          FB.logout();
          cookies.set("fb_name","",{path:""});
          cookies.set("access_token", "", {
              path: ""
          });
          cookies.set("fid", "", { path: "" });
          this.$bus.emit("logout", true);
        })
        .catch(() => {});
    },
    gotoWinRecord(){
      this.$router.push({path:'/winrecord'})
    }
  },
  components: {
    Register
  }
};
</script>


<style lang="stylus" scoped>
@import '../assets/variables.styl';

header {
  a {
    text-decoration: none;
    color: inherit;
  }

  .header-top {
    height: 50px;
    limit-width();
    position relative
    margin-bottom 20px

    .logo {
      position relative
      width 160px
      height: 32px;
      margin-bottom 6px
      font-size: 24px;
      font-weight: bold;
      color: #fc5755;
      background-image url(../assets/image/logo.png);
      background-size 100%
      background-repeat no-repeat
      .intro{
        position absolute
        bottom -20px
        left 0
        font-size 14px
        font-weight bold
        white-space nowrap
        color black
      }
    }

    .download {
      position absolute
      left 176px

      &-googleplay {
        width 78px
        height 24px
        margin-bottom 10px
        background-image url(../assets/image/vn_gp.png)
        background-size 100%
        background-repeat no-repeat
      }
    }

    .ruleTips{
      position absolute
      display block
      width 400px
      left 300px
      color blue

      &::before {
        position absolute
        content ''
        width 30px
        height 30px
        background url('https://image2.vnay.vn/topnews-2017/imgs/61/d1/61d15ce79a657b37516caed52073b23b.png') no-repeat
        background-size 100%
        left -34px
        top 5px
        animation changeOp linear .2s infinite alternate-reverse
      }

      @keyframes changeOp {
        0%{
          opacity 0.3
        }
        100%{
          opacity 1
        }
      }
    }

    .date {
      color: $color-primary;
    }
  }

  nav {
    height: 40px;
    line-height: 40px;
    color: white;
    background-color: $color-primary;
    overflow hidden
  }

  .nav-list {
    position: relative;
    transition height 1s;
    limit-width();

    // width 50%
    .more {
      position absolute
      width 40px
      height 40px
      right: -30px
      top 0
      &::after {
        content: '';
        position: absolute;
        width: 10px;
        height: 10px;
        left 13px
        top 10px;
        border: 1px solid #ffffff;
        border-left-color: transparent;
        border-top-color: transparent;
        transform: rotateZ(45deg);
        // right: 10px;
      }
    }
    li {
      cursor: pointer;
      padding: 0 0.5rem;
      min-width: 120px;
      text-align: center;

      &:hover {
        background-color: darken($color-primary, 30%);
      }

      &.active {
        background-color: darken($color-primary, 50%);
      }
    }
  }

  .user-name {
    display:inline-block;
    position:relative;
    box-sizing:border-box;
    max-width: 100px;
    font-size:1.2em;
    color: $color-primary;
    padding:0px 10px;
    cursor:pointer;
  }

  .user-name:hover+.person-panel{
    display:block;
  }
  ul{
    margin:0;
    padding:0;
    list-style:none;
  }
  .person-panel{
    display:none;
    position:absolute;
    top:50px;
    right:11vw;
    z-index:99;
    padding:4px 0;
    background:rgba(139,199,234,.8);
    border-bottom:1px solid #ccc;
    color:#000;
  }
  .panel-item{
    display:block;
    padding:6px 14px;
    cursor:pointer;
  }
  .panel-item:hover{
    background:#8bc7ea;
    color:#fff;
  }

  .person-panel:hover{
    display:block;

  }
  .person-panel:before {
    content: '';
    position:absolute;
    left:0;
    top:-20px;
    width:100%;
    height:20px;
  }

  .button-login {
    margin-bottom: 3px;
    border-radius: 20px;
    padding: 5px 10px;
    min-width: 80px;
    color: $color-sub;

    &:hover {
      color: $color-primary;
      border-color: $color-primary;
    }

    &:active {
      box-shadow: inset $color-sub 1px 1px 2px;
    }
  }
}
</style>





// WEBPACK FOOTER //
// Header.vue?2d0740f1